export default {
  message: {
    assetDistribution: "資產分佈",
    fixedReturn: "固定收益",
    trust: "信託",
    summary: "總覽",
    creditCard: "信用卡",
    cashMangement: "現金託管",
    othersAssets: "Others Assets",
    myassetDistribution: "我的資產分佈",
    elite: "晉永財富傳承信託計劃",
    signature: "匯智創富信託計劃",
    timelessVenture: "Timeless Venture Capital Fund",
    plan: "計劃",
    planName: "計劃名稱",
    newPlan: "新計劃",
    updatePlan: "修改計劃",
    subscriptedPlan: "認購計劃",
    subscriptedPlanEN: "認購計劃 (英)",
    subscriptedPlanZH: "認購計劃 (中)",
    customerCode: "客戶編號",
    currency: "貨幣",
    validDate: "生效日期",
    expiryDate: "到期日",
    balanceAmount: "認購金額",
    expectedAnnualReturn: "預計年化分配率",
    actualAnnualReturn: "實際年化分配率（每月更新）",
    beneficiary: "生前受益人",
    beneficiaryDeath: "身故受益人",
    details: "詳情",
    overview: "總覽",
    totalConFromEffectiveDate: "自帳戶生效日起計的總淨供款",
    totalConTransInAssets: "總供款/轉入資產",
    totalWithTransOutAssets: "總提取/轉出資產",
    profitorLossFromEffectiveDate: "自帳戶生效日起計的投資收益/虧損",
    accountBalance: "帳戶結存",
    accountReturns: "帳戶回報",
    quarterFundOverview: "季度基金概覽",
    notifications: "通知",
    addNotifications: "新增通知",
    newNotifications: "新通知",
    date: "日期",
    subject: "標題",
    detail: "內容",
    contactUs: "聯絡我們",
    agentNo: "信託專員編號",
    lastUpdate: "最後更新",
    customer: "客戶",
    customerName: "客戶名稱",
    addCustomer: "新增客戶",
    newCustomer: "新客戶",
    updateCustomer: "編輯客戶",
    profile: "個人資料",
    logout: "登出",
    hkd: "港元",
    back: "返回",
    confirm: "確定",
    update: "更新",
    cancel: "取消",
    add: "新增",
    name: "姓名",
    email: "電子郵件",
    content: "信息",
    send: "傳送",
    gender: "性別",
    phone: "電話",
    dateOfBirth: "出生年月",
    residentialAddress: "住宅地址",
    corrAddress: "通訊地址",
    confirmPwd: "確認密碼",
    resetPwd: "重設密碼",
    No: "編號",
    nickName: "名稱",
    balance: "結存",
    returns: "回報",
    selectFile: "選擇檔案",
    user: "用戶",
    staff: "職員",
    addUser: "新增用戶",
    newUser: "新用戶",
    updateUser: "編輯用戶",
    username: "用戶名",
    role: "角色",
    password: "密碼",
    agentNumber: "信託專員編號",
    createdAt: "創建日期",
    goLogin: "請重新登入。",
    USD: "美元 ",
    HKD: "港元 ",
    EUR: "歐元 ",
    RMB: "人民幣 ",
    male: "男",
    female: "女",
    edit: "編輯",
    pwdError: "兩次輸入的密碼不一致",
    sendSuccess: "傳送成功",
    errorMsg: "錯誤，請檢查後重新提交。",
    editPwd: "修改密碼",
    agent: "信託專員",
    clickHere: "點擊此處",
    signIn: "登入",
    goSignIn: "去登入?",
    forgotPwd: "忘記密碼？",
    partnerOf: "合作夥伴:",
    checkEmail: "傳送成功，請查閱您的郵箱。",
    checkEmail2: "已發出激活電郵至 ",
    checkEmail3: " , 請查閱郵箱。",
    checkEmail4: "已發出電郵至 ",
    accountError: "用戶名或者密碼錯誤，請重新輸入。",
    oldPwd: "舊密碼",
    oldPwdErrorMsg: "舊密碼錯誤，請重新嘗試。",
    approvalUser: "用戶審批",
    pendingApproval: "待審批",
    approved: "已批准",
    errorDel: "刪除失敗，請重新嘗試。",
    delete: "刪除",
    newPwd: "新密碼",
    newRePwd: "再次輸入新密碼",
    setPwd: "傳送成功",
    planTemplate: "計劃範本",
    addPlanTemplate: "新增範本",
    planTemplateZH: "計劃名稱(中)",
    planTemplateEN: "計劃名稱(英)",
    interestRate: "年利率(%)",
    dividendPeriod: "派息周期(月)",
    length: "計劃年期(月)",
    manageFee: "管理費(%)",
    managePeriod: "管理費收費周期(月)",
    newPlanTemplate: "新計劃範本",
    updatePlanTemplate: "編輯計劃範本",
    createSuccess: "新增成功",
    updateSuccess: "更新成功",
    deleteSuccess: "刪除成功",
    dividendMode: "派息模式",
    dividend: "派息",
    periods: "期數",
    dividendDate: "派息日期",
    interestRate1: "利率",
    interest: "利息",
    manageFee1: "管理費",
    interest1: "回報",
    grossInterest: "年度派息",
    accumulated: "累積利息",
    rolloverAmount: "複利息後客戶所得總額",
    status: "狀態",
    capital: "本金",
    chooseTemplate: "選擇計劃範本",
    dividendApproval: "收益分配安排",
    simple: "每年提取",
    compound: "滾存生息",
    halfYearly: "每半年提取",
    onHold: "排程中",
    pending: "審批中",
    approve: "批准",
    reject: "不批准",
    rejected: "不批准",
    issued: "已派息",
    expired: "已過期",
    complete: "完成派息",
    submit: "提交",
    clientCode: "客戶編號",
    clientName: "客戶名稱",
    must_be_number: "必須是數字",

    changePassword: "更改密碼",
    currentPassword: "目前密碼",
    newPassword: "新密碼",
    confirmNewPassword: "確認新密碼",
    enterCurrentPassword: "請輸入目前密碼",
    enterNewPassword: "請輸入新密碼",
    confirmNewPasswordPlaceholder: "請確認新密碼",
    updatePassword: "更新密碼",
    clear: "清除",
    error: "錯誤",
    success: "成功",
    passwordMismatch: "新密碼與確認密碼不一致",
    passwordLengthError: "密碼長度至少需要6個字符",
    passwordUpdateSuccess: "密碼更新成功",
    currentPasswordIncorrect: "目前密碼不正確",
    passwordUpdateFailed: "密碼更新失敗",
    passwordUpdateError: "更新密碼時發生錯誤",
    searchCustomer: "按姓名、代碼、用戶名、電郵或電話搜索",
    clearSearch: "清除搜索",
    fixedTermStatement: "《固定期限安排之責任聲明》：此賬戶上顯示的信託為委託人要求設立的不可撤銷信託，且就所涉固定期限安排（「固定期限安排」），委託人是經充分考慮後，自主選擇將相關信託資產配置於具固定期限、流動性限制及/或提前退出限制之安排，並知悉該安排可能涉及由獨立第三方機構根據其自身法律及商業條款管理、持有、配置或執行。委託人進一步確認，相關資產一經依其明確書面指示配置至上述安排後，將受適用之交易文件、相關第三方安排文件及/或其他具法律約束力文件規範，並非由受託人單方面控制或可由受託人單方面任意解除、撤回、變更或提前退出。\n在固定期限內，任何提前贖回、提前退出、資產轉移、信託終止、變更或分配要求（如有），須受本信託契約、本條款、相關第三方安排條款及適用法律約束，並可能因提前處置導致損失、罰則、流動性受限、價值受損或其他不利後果。委託人確認並接受該等風險。而受託人於處理任何該等要求時，應有權根據信託契約、相關交易安排、第三方約束及其作為受託人之職責，審慎考慮相關因素，包括但不限於對信託資產之保全、受益人整體利益、既有法律義務及相關安排下可能產生之風險與後果。委託人確認在固定期限安排項下任何預計年化分配率（如有）乃由相關獨立第三方提供，僅屬說明性質，並不構成受託人就收益、表現或結果作出任何保證、承諾或擔保。受託人僅依信託契約履行行政及託管職責，並不作為投資經理、投資顧問或回報保證人。除另有明確約定外，相關預計年化分配率（如適用）已反映並預先扣除受託人按信託資產總值每年收取之託管及行政費用。本條款應與主信託契約一併閱讀；如有不一致，應按主信託契約及適用法律解釋，並在可適用範圍內，使本條款充分反映委託人就固定期限安排之明確指示及各方原意。",
  },

  lang: {
    hi: "您好",
    total_balance: "總可用資產",
    total_credit: "總信用資產",
    currency: "貨幣計價單位",
    welcome: "歡迎來到您的信託帳戶",
    total_amount_of_fixed_custody: "定期信託託管份額",
    total_amount_of_current_custody: "託管資產淨值",
    fixed_custody_account_number: "定期託管編號",
    current_custody_account_number: "託管資產淨值編號",
    demand_trust_amount: "活存託管總金額",
    trust_advisor_number: "信託顧問編號",
    trust_account_id: "信託編號",
    total_amount: "信託資產總額",
    account_number: "帳戶活存編號",
    add_new: "添新",
    update_card: "更新卡",
    update_summary: "更新总结",
    create_fixed_trust_account: "定存帳戶編號",
    update_fixed_trust_account: "更新定存信托账户",
    create_demand_trust_amount: "创建活存信托金额",
    update_demand_trust_amount: "更新活存信托金额",
    summary_total_amount: "信託資產總額",
    fixed_trust_account_number: "定存信託帳號",
    demand_deposit_trust_amount_acount_number: "活存信託金額 帳號",

    credit_card: "信用卡",
    cash: "現金",
    fixed_return: "固定收益",
    fixed_custody: "定期信託託管份額",
    current_custody: "託管資產淨值",

    card_number: "卡號",
    expiry_date: "有效期限",
    card_holder_name: "持卡人姓名",
    total_credit_limit: "總信用額度",
    used_credit: "已用餘額",
    remaining_limit: "剩餘額度",

    latest_transactions: "近五筆交易明細",
    just_latest_transactions: "最新交易",
    create_transactions: "创建交易",
    update_transactions: "更新交易",
    spending_date: "支付日期",
    deduct_date: "扣款日期",
    spending_detail: "支付明細",
    spending_location: "支付地",
    international_ex_fee: "本地消費金額",
    usd_deduct_amount: "美元扣款金額",
    fx_charge_date: "外幣折算日",
    currency_type: "外幣幣別/金額",

    fixed_custody_number: "定期序號",
    effective_date: "生效日期",
    maturity_date: "到期日",
    management_currency: "貨幣",
    custody_amount: "託管資產",
    standard_return: "預計年化分配率",
    beneficiary: "生前受益人",
    beneficiary_after_death: "身故受益人",
    note: "備註",
    deposit_withdrawal: "注入／分配",
    amount: "資產",
    account_balance: "託管餘額",
    initial_deposit: "初始信託資本",
    interest_deposit: "收益分配",
    details: "詳情",
    deposit: "存入",
    withdrawal: "支出",
    usd: "美元",
    asset_type: "資產類別",
    unit: "單位",
    asset_total: "總資產價值/總預估價值",
    others_assets: "其他資產",
    add_other_asset: "添加其他資產",
    update_other_asset: "更新其他資產",
    before_beneficiary: "生前受益人",
    after_beneficiary: "身故受益人",
    remark: "備註",
  },
};
